import React, { Fragment } from 'react';
import { toast } from 'react-toastify';
import Breadcrumb from '../common/breadcrumb';
import {Redirect} from 'react-router';
import { MDBDataTableV5 } from 'mdbreact';
import axios from 'axios';

import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css'; // Import css

import '../../assets/scss/app-styles/users.scss'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faLifeRing } from '@fortawesome/free-solid-svg-icons'
class Summary extends React.Component{

    constructor(props) {
        super(props);
        this.state = {
            newRecordClicked: false,
            profileIdSelected: null,
            style: 'custom-spinner',
            loading: true,
		    backToIndex: false,
        };
    }
    headers = {
        headers: {
            Token: localStorage.getItem("token"),
        }
    }

    componentDidMount(){
        if(JSON.parse(localStorage.getItem('creds')).cloud_id !== "365SIP"){
			this.setState({backToIndex: true});
            this.setState({style: 'custom-spinner-hide'});
			return;
		}
        this.refreshData();
    }

    refreshData = () => {
        this.setState({style: 'custom-spinner'});
        const payLoad = {
            user_id: JSON.parse(localStorage.getItem('creds')).id
        };

        axios.post(`${process.env.REACT_APP_API_URL}profileSummary`, payLoad, this.headers)
        .then(response=>{
            this.createDataTable(response.data);
            this.setState({style: 'custom-spinner-hide'});
        })
        .catch(err=>{
            toast.error(err.message);
            this.setState({style: 'custom-spinner-hide'});
        });
    }

    createDataTable = (dataFromApi) => {

        let columns =[
            {
                label: 'Id',
                field: 'id',
            },
            {
                label: 'Profile Name',
                field: 'profilename',
            },
            {
                label: 'Host',
                field: 'host',
            },
            {
                label: 'Title',
                field: 'title',
            },
            {
                label: 'Transport',
                field: 'transport',
            },
            {
                label: 'Transport',
                field: 'transport',
            },
            {
                label: 'Edit - Delete - SOS',
                field: 'edit',
                sort: 'disabled',
            }
        ];

        let dataModified = null;
        if(dataFromApi != null)
        {
            dataFromApi = dataFromApi.map((row) => {
                if(row.outboundproxyenabled){
                    row.outboundproxyenabled = "Yes"
                }
                else {
                    row.outboundproxyenabled = "No"
                }

                return({...row});
            });
            dataModified = dataFromApi.map((row)=>{
                let specialNumbers = null;
                specialNumbers = <FontAwesomeIcon className="data-table-icon" icon={faLifeRing} onClick={this.openSpecialNumbersHandler} data-id={row.id} data-id2={row.subscriber_id} data-name={row.profilename} />
                return ({...row, edit:  <div className="edit-column">
                <i className="far fa-edit data-table-icon"
                    onClick={this.editHandler} data-id={row.id}></i> -
                <i className="far fa-trash-alt data-table-icon"
                    onClick={this.deleteHandler} data-id={row.id}></i> -
                {specialNumbers}
                </div>});
            });

        }
        this.setState({dataTable: {columns: columns, rows: dataModified}});
        this.setState({loading: false});
    }

    deleteHandler = (event) =>{
        confirmAlert({
            title: 'Are you sure you want to delete this client profile detail?',
            message: '',
            buttons: [
                {
                    label: 'Delete',
                    onClick: () => {
                        this.setState({style: 'custom-spinner'});
                        const payLoad = {
                            id : event.target.getAttribute("data-id"),
                            user_id: JSON.parse(localStorage.getItem('creds')).id,
                        };
                        this.setState({style: 'custom-spinner'});
                        axios.post(`${process.env.REACT_APP_API_URL}deleteProfile`, payLoad, this.headers)
                        .then(response=>{
                            toast.success("Record Deleted");
                            this.setState({style: 'custom-spinner-hide'});
                            this.refreshData();
                        })
                        .catch(err=>{
                            toast.error(err.message);
                            this.setState({style: 'custom-spinner-hide'});
                        });
                    }
                },
                {
                    label: 'Cancel',
                    onClick: () => {
                    }
                }
            ]
            
        });
    }

    editHandler = (event) =>{
        this.setState({profileIdSelected: event.target.getAttribute("data-id")})
        // will call the details compnent but with data id selected here as a prop

    }

    addNewHandler = (evt) => {
        evt.preventDefault();

        this.setState({newRecordClicked: true});

    }
    openSpecialNumbersHandler = (evt) => {
        evt.preventDefault();
        this.setState({templateId: evt.currentTarget.getAttribute("data-id")});
        this.setState({subscriberIdSelected: evt.currentTarget.getAttribute("data-id2")});
        this.setState({profileNameSelected: evt.currentTarget.getAttribute("data-name")});
        this.setState({openSpecialNumbersClicked: true});
    }

    render() {

        let redirect = null;
        if(this.state.openSpecialNumbersClicked){
            this.setState({openSpecialNumbersClicked: false});
            redirect = <Redirect to = {{
                pathname: "/client_profiles/SpecialNumbers",
                state: { client_profile_id: this.state.templateId, subscriber_id: this.state.subscriberIdSelected, profileNameSelected: this.state.profileNameSelected}
            }} />;
        }
        if(this.state.newRecordClicked){
            this.setState({newRecordClicked: false});
            redirect = <Redirect to = {{
                pathname: "/client_profiles/details",
                state: { id: null}
            }} />;

        }
        
        if(this.state.profileIdSelected){
            this.setState({profileIdSelected: null});
            redirect = <Redirect to = {{
                pathname: "/client_profiles/details",
                state: { id: this.state.profileIdSelected}
            }} />;
        }

            if(this.state.backToIndex){
                redirect = <Redirect to = {{
                        pathname: "/dashboard"
                }} />;
            }

        return(
            <Fragment>
                <Breadcrumb parent="App" title="Client Profiles" />
                <div className={"loader-box " + this.state.style} >
                    <div className="loader">
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    <div className="line bg-primary"></div>
                    </div>
                </div>
                {redirect}

                <div className = "MainIndex">
                    <div className="row" style={{float:"right"}}>
                        <button onClick={this.addNewHandler} type="button"  className="btn btn-rounded-custom btn-primary table-btn" >Add New </button>
                    </div>
                    <div className="users-table">
                    <MDBDataTableV5 hover entriesOptions={[10, 20, 30]} entries={10}
                    pagesAmount={4} data={this.state.dataTable} searchTop  searchBottom={false} />

                    </div>
                </div>

            </Fragment>

        );

    }

}

export default Summary;
